import { Box, Button, Typography } from "@mui/material";
import { Link, useSearch } from "@tanstack/react-router";

import { skuStoreMediaSearchForGroup } from "@/features/Generations/pilotFlowGroup";
import { CheckCircleIcon } from "@/icons";

export type PublishedStateProps = { siteId: string };

export function PublishedState({ siteId }: PublishedStateProps) {
  // The collection flow retains the target group in the URL (see its route's
  // search middleware), which is what the SKU Store media deep link needs.
  const search = useSearch({ strict: false });
  const mediaSearch = skuStoreMediaSearchForGroup(
    typeof search.groupType === "string" ? search.groupType : undefined,
    typeof search.groupName === "string" ? search.groupName : undefined,
  );

  return (
    <Box
      data-testid="generations-published-state"
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 3,
        px: 6,
      }}
    >
      <CheckCircleIcon sx={{ fontSize: 56, color: "success.main" }} />
      <Box>
        <Typography variant="h5" fontWeight={700}>
          Collection published
        </Typography>
        <Typography color="text.secondary" sx={{ mt: 1 }}>
          Your accepted assets are live. The generation is complete.
        </Typography>
      </Box>
      <Box sx={{ display: "flex", gap: 2 }}>
        <Button
          variant="outlined"
          component={Link}
          to="/generations/$siteId"
          params={{ siteId }}
        >
          Back to generations
        </Button>
        <Button
          variant="contained"
          component={Link}
          to="/sku-store/$siteId"
          params={{ siteId }}
          search={mediaSearch}
        >
          View media
        </Button>
      </Box>
    </Box>
  );
}
